import { render, staticRenderFns } from "./CrmLeadDetailUi.vue?vue&type=template&id=b08d3a6e&scoped=true&lang=pug&"
import script from "./CrmLeadDetailUi.vue?vue&type=script&lang=js&"
export * from "./CrmLeadDetailUi.vue?vue&type=script&lang=js&"
import style0 from "./CrmLeadDetailUi.vue?vue&type=style&index=0&id=b08d3a6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08d3a6e",
  null
  
)

export default component.exports